import styled from 'styled-components'

const WrapFilterUser = styled.div`
    position: relative;
`;

export {
    WrapFilterUser
}